module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_kamakura-28583a20416f92e0f9c22bf6425fc209.jpg";